// app/features/activation/hooks/useActivationNewsletterTrigger.ts
"use client";

import { useEffect } from "react";

import { useAuthStore } from "@/app/auth/services_and_hooks/authStore";
import { activationService } from "@/app/shared/services_and_hooks/activationService";

import {
  claimActivationNewsletterOnce,
  runActivationNewsletterCommand,
} from "./activationNewsletterCommand";

/**
 * Welcome-newsletter delivery is also driven by the activation commands
 * (create organization, create workflow, newsletter subscribe), but not every
 * path reaches one: the dashboard's news-subscription modal calls
 * profileApiService.subscribeToNews directly, and any in-flow call that fails
 * on the network has no other retry. This session-level check is that retry.
 *
 * claimActivationNewsletterOnce() gates it to a single attempt per session, and
 * the backend endpoint is idempotent on top of that.
 */
export function useActivationNewsletterTrigger() {
  const user = useAuthStore((state) => state.user);
  const hasCompletedOnboarding = useAuthStore(
    (state) => state.hasCompletedOnboarding,
  );

  useEffect(() => {
    const claimed = claimActivationNewsletterOnce({
      hasUser: Boolean(user),
      hasCompletedOnboarding: Boolean(hasCompletedOnboarding),
    });
    if (!claimed) return;

    void runActivationNewsletterCommand(() =>
      activationService.triggerActivationComplete(),
    );
  }, [user, hasCompletedOnboarding]);
}
